function filterShopifyEvent(event, domElement, callback) {
    let executeCallback = false;
    if (event.type.includes('shopify:section')) {
        if (domElement.hasAttribute('data-section-id') && domElement.getAttribute('data-section-id') === event.detail.sectionId) executeCallback = true
    } else if (event.type.includes('shopify:block') && event.target === domElement) { 
        executeCallback = true 
    }
    if (executeCallback) callback(event)
}

// is in viewport
function inViewport(elem, callback, options = {}) {
    return new IntersectionObserver(entries => {
        entries.forEach(entry => callback(entry))
    }, options).observe(document.querySelector(elem));
}

/* How to inViewport
document.addEventListener("DOMContentLoaded", () => {
    inViewport('[data-inviewport]', element => {
        if (!element.isIntersecting) { document.querySelector('#add2cart-cta').classList.add('active') } 
        else { document.querySelector('#add2cart-cta').classList.remove('active') }
    });
});
*/

// Toggle Body Class
let toggleBodyClass = function(arg) { 
    document.body.classList.toggle(arg);
}
// Get Element Height
function getElementHeight(targetElement,appendTo,cssVar) {
    let element = document.querySelector(targetElement);

    if (element) {
        let elementHeight = element.offsetHeight;
        document.querySelector(appendTo).style.setProperty(cssVar, `${elementHeight}px`);
    }
}

// first we get the viewport height and we multiple it by 1% to get a value for a vh unit
const getSetVh = () => { const roundedVh = Math.round(window.innerHeight * 0.01); document.body.style.setProperty('--vh', `${roundedVh}px`) };
window.addEventListener('resize', getSetVh);

// Browser check
function getNavigator() {
    const isiOS = navigator.userAgent.match(/(iPhone|iPad|iPod)/) && navigator.userAgent.match(/AppleWebKit/) && !navigator.userAgent.match(/CriOS/);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0 || navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime) || navigator.userAgent.indexOf('Chrome') != -1;
    const isFirefox = typeof InstallTrigger !== 'undefined' || navigator.userAgent.indexOf('Firefox') != -1;
    const isEdge = !!window.StyleMedia || navigator.userAgent.indexOf('Edge') != -1

    if (isiOS) document.documentElement.classList.add('ios');
    if (isSafari) document.documentElement.classList.add('safari');
    if (isChrome) document.documentElement.classList.add('chrome');
    if (isFirefox) document.documentElement.classList.add('firefox');
    if (isEdge) document.documentElement.classList.add('edge');
}

// Toggle
    let toggleClass = function(qSelectors, bodyClass) {   
        document.querySelectorAll(qSelectors).forEach(e => e.addEventListener('click', () => toggleBodyClass(bodyClass)))
    }
// Menu
    let toggleMenu = function() { 
        toggleClass('.fire-menu, .shrink-menu', 'open-menu')
    }


    function initializeDetailsControls() {
        // Handle dropdown menu
        const detailsElementsLv1 = document.querySelectorAll('details.lv1');
        const detailsElementsClosex = [...document.querySelectorAll('details.closex')];
    
        function closeOtherDetails(element) {
            const detailsOpened = document.querySelectorAll('details[open].lv1');
            for (const item of detailsOpened) {
                if (element !== item) {
                    item.removeAttribute('open');
                }
            }
        }

        function closeAllDetailsExcept(target) {
            detailsElementsClosex.forEach(f => !f.contains(target) ? f.removeAttribute('open') : '');
            a11yDetails();
        }
    
        function closeAllDetails() {
            detailsElementsClosex.forEach(f => f.removeAttribute('open'));
            a11yDetails();
        }
    
        // Dropdown menu
        detailsElementsLv1.forEach(item => {
            item.addEventListener('click', function() {
                closeOtherDetails(this);
            });
        });
    
        // Close details when clicked outside
        document.addEventListener('click', function(e) {
            if (!detailsElementsClosex.some(f => f.contains(e.target))) {
                closeAllDetails();
            } else {
                closeAllDetailsExcept(e.target);
            }
        });
    
        // Close details with esc key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' || e.keyCode === 27) {
                closeAllDetails();
            }
        });
    
        // Initial accessibility settings
        a11yDetails();
    }

    function a11yDetails() {
        document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
            summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
            
            if(summary.nextElementSibling.getAttribute('id')) {
                summary.setAttribute('aria-controls', summary.nextElementSibling.id);
            }
            
            summary.addEventListener('click', (event) => {
                event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
            });
        });
    }
    

// update button price on variant change 
function updatePrice(obj,idd) {
    var uid = obj.options[obj.selectedIndex].getAttribute('data-price');
    var pb = document.querySelector('.uprice'+idd);
    pb.innerHTML = uid;
}

function selectOptions(obj,idd) { updatePrice(obj,idd) }

// Debug
if (window.location.href.indexOf("debug") > -1) {
    var OpenThinking = OpenThinking || {}; OpenThinking.theme = { "name":"Bullet", "version":`${window.BOOMR.themeVersion}` };
    console.log(`${OpenThinking.theme.name} v${OpenThinking.theme.version}`);
}

// Bullet marquee
if (!customElements.get('bullet-marquee')) customElements.define('bullet-marquee', class bulletMarquee extends HTMLElement {
    constructor() { super(); if (window.ResizeObserver) new ResizeObserver(this.duration.bind(this)).observe(this); }

    duration(entries) {
        const scrollingSpeed = parseInt(this.getAttribute('bullet-speed') || 5);
        const contentWidth = entries[0].contentRect.width;
      
        // Calculate the slowFactor based on content width
        let slowFactor = contentWidth <= 375 ? 1 : contentWidth >= 1280 ? 3 : 1 + (contentWidth - 375) / (1280 - 375);

        // Calculate the scrolling speed with the adjusted slowFactor
        const scrollingDuration = (scrollingSpeed * slowFactor * entries[0].target.querySelector('span').clientWidth / contentWidth).toFixed(3);

        this.style.setProperty('--bullet-speed', `${scrollingDuration}s`);
    }
});

/*** init app */
function app() {
    getSetVh(); // get Viewport Height
    getNavigator(); // get the browser + OS
    toggleMenu(); // toggle Menu
    initializeDetailsControls(); // call details 
}

/*** on DOM ready **/
document.addEventListener("DOMContentLoaded", () => { app() })

document.addEventListener("DOMContentLoaded", function() {
  // Function to get all query parameters with the same name (e.g., 'filter.p.tag')
  function getUrlParameters(name) {
      var params = new URLSearchParams(window.location.search);
      var values = params.getAll(name);
      return values; // Returns an array of all the values for the same query parameter
  }

  // Get all 'filter.p.tag' values
  var filterTags = getUrlParameters('filter.p.tag');
  

  // Update the div for 'filter.p.tag' values
  if (filterTags) {
      var filterTagDiv = document.getElementById('filterTagDiv');
      filterTags.forEach(function(tag) {
          var span = document.createElement('span');
          span.innerText = tag;
          filterTagDiv.appendChild(span);
          // Optional: Add space or separator between tags
          filterTagDiv.appendChild(document.createTextNode(' ')); 
      });
  }
});

//Amazon Verified badge
// Amazon Verified Badge for "Cloud Control Hair Oil"
function assignAmazonVerifiedCloudControl() {
    const reviews = document.querySelectorAll('[data-product-title="Hydrating Hair Oil"]');
    const selectedReviews = Array.from(reviews).sort(() => 0.5 - Math.random()).slice(0, 2);
    reviews.forEach(review => {
        const badge = review.querySelector('.jdgm-rev__buyer-badge');
        if (badge) badge.classList.remove('amazon-verified');
    });
    selectedReviews.forEach(review => {
        const badge = review.querySelector('.jdgm-rev__buyer-badge');
        if (badge) badge.classList.add('amazon-verified');
    });
}

// Polling function for "Cloud Control Hair Oil"
function startPollingCloudControl(interval = 1000) {
    let lastReviewCount = 0;
    setInterval(() => {
        const reviews = document.querySelectorAll('[data-product-title="Hydrating Hair Oil"]');
        if (reviews.length !== lastReviewCount) {
            lastReviewCount = reviews.length;
            assignAmazonVerifiedCloudControl();
        }
    }, interval);
}

// Amazon Verified Badge for "Hydrating Pomade"
function assignAmazonVerifiedHydratingPomade() {
    const reviews = document.querySelectorAll('[data-product-title="Hydrating Pomade"]');
    const selectedReviews = Array.from(reviews).sort(() => 0.5 - Math.random()).slice(0, 2);
    reviews.forEach(review => {
        const badge = review.querySelector('.jdgm-rev__buyer-badge');
        if (badge) badge.classList.remove('amazon-verified');
    });
    selectedReviews.forEach(review => {
        const badge = review.querySelector('.jdgm-rev__buyer-badge');
        if (badge) badge.classList.add('amazon-verified');
    });
}

// Polling function for "Hydrating Pomade"
function startPollingHydratingPomade(interval = 1000) {
    let lastReviewCount = 0;
    setInterval(() => {
        const reviews = document.querySelectorAll('[data-product-title="Hydrating Pomade"]');
        if (reviews.length !== lastReviewCount) {
            lastReviewCount = reviews.length;
            assignAmazonVerifiedHydratingPomade();
        }
    }, interval);
}

// Amazon Verified Badge for "Matte Cream Clay"
function assignAmazonVerifiedMatteCreamClay() {
    const reviews = document.querySelectorAll('[data-product-title="Matte Cream Clay"]');
    const selectedReviews = Array.from(reviews).sort(() => 0.5 - Math.random()).slice(0, 2);
    reviews.forEach(review => {
        const badge = review.querySelector('.jdgm-rev__buyer-badge');
        if (badge) badge.classList.remove('amazon-verified');
    });
    selectedReviews.forEach(review => {
        const badge = review.querySelector('.jdgm-rev__buyer-badge');
        if (badge) badge.classList.add('amazon-verified');
    });
}

// Polling function for "Matte Cream Clay"
function startPollingMatteCreamClay(interval = 1000) {
    let lastReviewCount = 0;
    setInterval(() => {
        const reviews = document.querySelectorAll('[data-product-title="Matte Cream Clay"]');
        if (reviews.length !== lastReviewCount) {
            lastReviewCount = reviews.length;
            assignAmazonVerifiedMatteCreamClay();
        }
    }, interval);
}

// Amazon Verified Badge for "Heavy Hold Clay"
function assignAmazonVerifiedHeavyHoldClay() {
    const reviews = document.querySelectorAll('[data-product-title="Heavy Hold Clay"]');
    const selectedReviews = Array.from(reviews).sort(() => 0.5 - Math.random()).slice(0, 2);
    reviews.forEach(review => {
        const badge = review.querySelector('.jdgm-rev__buyer-badge');
        if (badge) badge.classList.remove('amazon-verified');
    });
    selectedReviews.forEach(review => {
        const badge = review.querySelector('.jdgm-rev__buyer-badge');
        if (badge) badge.classList.add('amazon-verified');
    });
}

// Polling function for "Heavy Hold Clay"
function startPollingHeavyHoldClay(interval = 1000) {
    let lastReviewCount = 0;
    setInterval(() => {
        const reviews = document.querySelectorAll('[data-product-title="Heavy Hold Clay"]');
        if (reviews.length !== lastReviewCount) {
            lastReviewCount = reviews.length;
            assignAmazonVerifiedHeavyHoldClay();
        }
    }, interval);
}

// Amazon Verified Badge for "Wax Fiber"
function assignAmazonVerifiedWaxFiber() {
    const reviews = document.querySelectorAll('[data-product-title="Wax Fiber"]');
    const selectedReviews = Array.from(reviews).sort(() => 0.5 - Math.random()).slice(0, 2);
    reviews.forEach(review => {
        const badge = review.querySelector('.jdgm-rev__buyer-badge');
        if (badge) badge.classList.remove('amazon-verified');
    });
    selectedReviews.forEach(review => {
        const badge = review.querySelector('.jdgm-rev__buyer-badge');
        if (badge) badge.classList.add('amazon-verified');
    });
}

// Polling function for "Wax Fiber"
function startPollingWaxFiber(interval = 1000) {
    let lastReviewCount = 0;
    setInterval(() => {
        const reviews = document.querySelectorAll('[data-product-title="Wax Fiber"]');
        if (reviews.length !== lastReviewCount) {
            lastReviewCount = reviews.length;
            assignAmazonVerifiedWaxFiber();
        }
    }, interval);
}

// Initialize for all products
document.addEventListener('DOMContentLoaded', () => {
    assignAmazonVerifiedCloudControl();
    startPollingCloudControl();

    assignAmazonVerifiedHydratingPomade();
    startPollingHydratingPomade();

    assignAmazonVerifiedMatteCreamClay();
    startPollingMatteCreamClay();

    assignAmazonVerifiedHeavyHoldClay();
    startPollingHeavyHoldClay();

    assignAmazonVerifiedWaxFiber();
    startPollingWaxFiber();
});

// Add CSS for the Amazon Verified badge
const style = document.createElement('style');
style.textContent = `.amazon-verified::before { content: "Amazon Verified" !important; }`;
document.head.appendChild(style);

// Create an observer to watch for changes in the DOM
const observer = new MutationObserver(function(mutationsList, observer) {
  // Select the first child .jdgm-subtab__name
  const nameElement2 = document.querySelector('.jdgm-subtab__name:first-child');
  if (nameElement2) {
    // Update the inner HTML to 'Reviews'
    nameElement2.innerHTML = 'Reviews';
  }

  // Select the second child .jdgm-subtab__name
  const nameElement = document.querySelector('.jdgm-subtab__name:nth-child(2)');
  if (nameElement) {
    // Update the inner HTML to 'Questions'
    nameElement.innerHTML = 'Questions';
  }

  // Disconnect the observer after the changes are made
  if (nameElement2 && nameElement) {
    observer.disconnect();
  }
});

// Configure the observer to watch for added nodes in the body
observer.observe(document.body, {
  childList: true,
  subtree: true
});


document.addEventListener('DOMContentLoaded', function () {
    // Select the first thumbnail button
    const firstThumbnailButton = document.querySelector('#shopify-section-template--16367940239426__main .thumbnail-slider__slide:first-child .thumbnail');

    // Add aria-current="true" to the first thumbnail button
    if (firstThumbnailButton) {
        firstThumbnailButton.setAttribute('aria-current', 'true');
    }
});

document.addEventListener("DOMContentLoaded", function () {
    // Select elements
    const mainSlider = document.querySelector("#shopify-section-template--16367940239426__main #Slider-Gallery-main");
    const slides = document.querySelectorAll("#shopify-section-template--16367940239426__main .slider__slide");
    const thumbnails = document.querySelectorAll("#shopify-section-template--16367940239426__main .thumbnail-slider__slide button");
    const totalSlides = slides.length;

    let currentIndex = 0;
    let isDragging = false;
    let startX;
    let scrollLeft;

    // Function to update active thumbnail based on main image scroll
    function updateActiveThumbnail(index) {
        if (index < 0) index = 0;
        if (index >= totalSlides) index = totalSlides - 1;

        // Remove active states
        thumbnails.forEach(thumb => thumb.removeAttribute("aria-current"));

        // Add active state to the correct thumbnail
        thumbnails[index].setAttribute("aria-current", "true");

        // Scroll active thumbnail into view
        thumbnails[index].scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });

        currentIndex = index;
    }

    // Detect swipe gesture on mobile
    let touchStartX = 0;
    let touchEndX = 0;
    let minSwipeDistance = 50;

    mainSlider.addEventListener("touchstart", (e) => {
        touchStartX = e.touches[0].clientX;
    });

    mainSlider.addEventListener("touchend", (e) => {
        touchEndX = e.changedTouches[0].clientX;
        let swipeDistance = touchStartX - touchEndX;

        if (swipeDistance > minSwipeDistance && currentIndex < totalSlides - 1) {
            updateActiveThumbnail(currentIndex + 1);
        } else if (swipeDistance < -minSwipeDistance && currentIndex > 0) {
            updateActiveThumbnail(currentIndex - 1);
        }
    });

    // Click event for thumbnails
    thumbnails.forEach((thumb, index) => {
        thumb.addEventListener("click", () => {
            updateActiveThumbnail(index);
        });
    });

    // **🔹 Dragging Functionality for Desktop**
    mainSlider.addEventListener("mousedown", (e) => {
        isDragging = true;
        startX = e.pageX - mainSlider.offsetLeft;
        scrollLeft = mainSlider.scrollLeft;
    });

    mainSlider.addEventListener("mouseup", () => {
        isDragging = false;
        snapToClosestSlide(); // 🔹 After dragging, sync thumbnail
    });

    mainSlider.addEventListener("mouseleave", () => {
        isDragging = false;
    });

    mainSlider.addEventListener("mousemove", (e) => {
        if (!isDragging) return;
        e.preventDefault();
        const x = e.pageX - mainSlider.offsetLeft;
        const walk = (x - startX) * 2; // Adjust speed
        mainSlider.scrollLeft = scrollLeft - walk;
    });

    // **🔹 Function to Snap to Closest Image**
    function snapToClosestSlide() {
        let closestIndex = Math.round(mainSlider.scrollLeft / slides[0].offsetWidth);
        updateActiveThumbnail(closestIndex);
    }

    // **🔹 Ensure thumbnails sync properly on desktop scroll**
    mainSlider.addEventListener("scroll", () => {
        if (!isDragging) {
            snapToClosestSlide();
        }
    });

    // Set first thumbnail as active
    updateActiveThumbnail(0);
});

document.addEventListener("DOMContentLoaded", function () {
    const slider = document.querySelector("#shopify-section-template--16367940239426__main #Slider-Gallery-main");

    let isDown = false;
    let startX;
    let scrollLeft;

    // Function to start dragging
    function startDrag(e) {
        isDown = true;
        slider.classList.add("active");
        startX = (e.pageX || e.touches[0].pageX) - slider.offsetLeft;
        scrollLeft = slider.scrollLeft;
    }

    // Function to stop dragging
    function endDrag() {
        isDown = false;
        slider.classList.remove("active");
        snapToClosestSlide(); // 🔹 Sync after drag
    }

    // Function to move slider
    function moveSlider(e) {
        if (!isDown) return;
        e.preventDefault();
        const x = (e.pageX || e.touches[0].pageX) - slider.offsetLeft;
        const walk = (x - startX) * 2; // Adjust speed
        slider.scrollLeft = scrollLeft - walk;
    }

    // Mouse Events (for desktop)
    slider.addEventListener("mousedown", startDrag);
    slider.addEventListener("mouseleave", endDrag);
    slider.addEventListener("mouseup", endDrag);
    slider.addEventListener("mousemove", moveSlider);

    // Touch Events (for mobile)
    slider.addEventListener("touchstart", startDrag);
    slider.addEventListener("touchend", endDrag);
    slider.addEventListener("touchmove", moveSlider);

    // **🔹 Function to Snap to Closest Image**
    function snapToClosestSlide() {
        let slides = document.querySelectorAll("#shopify-section-template--16367940239426__main .slider__slide");
        let closestIndex = Math.round(slider.scrollLeft / slides[0].offsetWidth);
        updateActiveThumbnail(closestIndex);
    }
});

